import React from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import BasicTextField from "../../SharedComponents/BasicTextField/BasicTextField";
import BasicLabel from "../../SharedComponents/BasicLabel/BasicLabel";
import BasicButton from "../../SharedComponents/BasicButton/BasicButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import SelectField from "../../SharedComponents/SelectField/SelectField";
import ClearTrackService from '../../../services/service';
import * as Constants from '../../../constants/constants';
import SearchSelectField from "../../SharedComponents/SearchSelectField";
import './LookupMaintenance.scss'
import axios from 'axios';
import { withUserContext } from "../../../contexts/UserContext";
import NotificationComponent from "../../../Common/NotificationComponent/NotificationComponent";
import BasicTextArea from "../../SharedComponents/BasicTextArea/BasicTextArea";
import WarningNotesModal from "../../SharedComponents/WarningNotesModal/WarningNotesModal";
import { checkEntityWarningNotes, closeWarningNotesModal, emptyWarningNotesModal, loadWriterWarningNotes, canEditWarningNotes } from "../../../Common/warningNotesHelper";

class OnflyLookup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            affilationOptions: [],
            writersDetails: null,
            cueSheetPubDetails:null,
            performerDetails:null,
            showDuplicateNotification: false,
            warningNotesModal: { ...emptyWarningNotesModal },
        };
    }

    showEntityWarningNotes = (entityKey, entityId, entityName, warningNotes) => {
        checkEntityWarningNotes(this, {
            entityKey,
            entityId,
            entityName,
            warningNotes
        });
    };

    componentDidMount() {
        if (this.props?.type === 'writer') {
            this.loadWriterDetails();
        }
        if (this.props?.type === 'cueSheetPublisher') {
            if (this.props?.cueSheetPubId && this.props?.cueSheetPubId !== 'new') {
                this.getCueSheetData(this.props?.cueSheetPubId);
            } else {
                this.setState({ cueSheetPubDetails: { name: null, warning_notes: null } });
            }
        }
        if (this.props?.type === 'performer') {
            if (this.props?.performerId && this.props?.performerId !== 'new') {
                this.getPerformerData(this.props?.performerId);
            } else {
                this.setState({ performerDetails: { name: null, warning_notes: null } });
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (
            this.props?.type === 'writer' &&
            this.props?.writerId !== 'new' &&
            (prevProps?.writerId?.value !== this.props?.writerId?.value ||
                prevProps?.selectedWriterIndex !== this.props?.selectedWriterIndex)
        ) {
            this.loadWriterDetails();
        }
    }

    // getWriterData = (id) => {
    //     this.setState({ isFetchingData: true })
    //     ClearTrackService.getData(Constants.ClearTrackServiceBaseUrl +
    //         `/entitySearch?entity=WRITER&searchString=${id?.text}`, this.props.userContext?.active_tenant?.tenant_id)
    //         .then(response => {
    //             let  writerData = response.data?.find(item => (item?.writer_id == id?.value && item?.song_id == this.props?.songDetails?.song_id));
    //             this.setState({ writersDetails: writerData, isFetchingData: false });
    //         },
    //             (err) => {
    //                 console.log("Error in fetching Address Types:", err);
    //                 this.setState({ writersDetails: null, isFetchingData: false });
    //             })
    // }

    getCueSheetData = (id) => {
        this.setState({ isFetchingData: true })
        ClearTrackService.getData(Constants.ClearTrackServiceBaseUrl +
            `/staticData?staticTable=lu_cue_sheet_publisher`, this.props.userContext?.active_tenant?.tenant_id)
            .then(response => {
                let cueSheetData = response.data?.find(item => item?.id == id);
                this.setState({ cueSheetPubDetails: cueSheetData, isFetchingData: false });
                if ((this.props?.origin === 'clearanceRecord' || this.props?.origin === 'fromMainTitleOrClearance') && cueSheetData?.id) {
                    this.showEntityWarningNotes('cueSheetPublisher', cueSheetData.id, cueSheetData.name, cueSheetData.warning_notes);
                }
            },
                (err) => {
                    console.log("Error in fetching Address Types:", err);
                    this.setState({ cueSheetPubDetails: null, isFetchingData: false });
                })
    }


    handleResetNotify = () => {
        this.setState({ showDuplicateNotification: false, pendingPostJson: null});
    };

    getPerformerData = (idOrName, type = 'id') => {
        this.setState({ isFetchingData: true })
        ClearTrackService.getData(Constants.ClearTrackServiceBaseUrl +
            `/staticData?staticTable=lu_performer`, this.props.userContext?.active_tenant?.tenant_id)
            .then(response => {
                const data = response.data || [];
                let performerMatch = null;
                if (type === 'name') {
                const nameToCheck = idOrName?.toLowerCase();
                performerMatch = data.find(item => item?.name?.toLowerCase() === nameToCheck);
                    if (performerMatch) {
                        this.setState({ pendingPostJson: performerMatch, showDuplicateNotification: true });
                    } else {
                        this.postPerformer(false);
                    }
                 } else if (type === 'id') {
                    performerMatch = data.find(item => item?.id == idOrName);
                    this.setState({ performerDetails: performerMatch });
                    if ((this.props?.origin === 'clearanceRecord' || this.props?.origin === 'fromMainTitleOrClearance') && performerMatch?.id) {
                        this.showEntityWarningNotes('performer', performerMatch.id, performerMatch.name, performerMatch.warning_notes);
                    }
                 }
                 this.setState({ isFetchingData: false });
            },
                (err) => {
                    console.log("Error in fetching Address Types:", err);
                    this.setState({ performerDetails: null, isFetchingData: false });
                })
    }

    handleWriterSubmit = () => {
        this.setState({ postInitiated: true });
        if (this.state.writersDetails?.writer_name) {
            this.setState({ postInitiated: false,isSubmit: true });
            let writerData = {
                ...this.state.writersDetails,
                is_active: 1,
            };
            ClearTrackService.postDataParams(Constants.ClearTrackServiceBaseUrl + `/writer`, writerData, this.props?.userContext?.active_tenant?.tenant_id
            ).then((response) => {
                let writerData = {
                    value: response?.data[0]?.writer_id,
                    text: `${this.state.writersDetails?.writer_name}${this.state.affilationOptions?.find(item => item?.value === this.state.writersDetails?.affiliation_id)?.label !=undefined ? " ("+this.state.affilationOptions?.find(item => item?.value === this.state.writersDetails?.affiliation_id)?.label+")" :""} ${(this.state.writersDetails?.share_percentage !=undefined && this.state.writersDetails?.share_percentage !=0) ? this.state.writersDetails?.share_percentage:""}`,
                    temp_text: `${this.state.writersDetails?.writer_name}${this.state.affilationOptions?.find(item => item?.value === this.state.writersDetails?.affiliation_id)?.label !=undefined ? "-"+this.state.affilationOptions?.find(item => item?.value === this.state.writersDetails?.affiliation_id)?.label :""} ${(this.state.writersDetails?.share_percentage !=undefined && this.state.writersDetails?.share_percentage !=0) ? this.state.writersDetails?.share_percentage:""}`,
                    affiliation_id: this.state.writersDetails?.affiliation_id || null,
                    affiliation_name: this.state.affilationOptions?.find(item => item?.value === this.state.writersDetails?.affiliation_id)?.label || null,
                    warning_notes: this.state.writersDetails?.warning_notes || null,
                }
                this.props.handleAddWriter(writerData)
                this.setState({isSubmit: false})
            },
                (err) => {
                     this.setState({ isSubmit: false });
                }
            );
        }
    };

    postCueSheetPub = () => {
        this.setState({ postInitiated: true })
        if (this.state.cueSheetPubDetails?.name) {
            this.setState({ postInitiated: false, isSubmit:true });
            let cuesheetPublisherData = { ...this.state.cueSheetPubDetails, is_active: 1, table_name: "lu_cue_sheet_publisher" }
            ClearTrackService.postDataParams(Constants.ClearTrackServiceBaseUrl + `/staticData`,
                cuesheetPublisherData,
                this.props?.userContext?.active_tenant?.tenant_id)
                .then(
                    (response) => {
                        let cueSheetPubData = {
                            value: response?.data[0]?.id,
                            text: `${this.state.cueSheetPubDetails?.name}`,
                            warning_notes: this.state.cueSheetPubDetails?.warning_notes || null,
                        }
                        this.props.handleCueSheetPubUpdate(cueSheetPubData)
                        this.setState({isSubmit: false})
                    },
                    (err) => {
                        this.setState({ isSubmit: false });
                    }
                )
        }
    };

    postPerformer = (checkDupilcate = true) => {
        this.setState({ postInitiated: true })
        if (this.state.performerDetails?.name) {
             if (this.props?.performerId == null && checkDupilcate) {
                this.getPerformerData(this.state.performerDetails?.name, "name");               
                return; 
            }
            this.setState({ postInitiated: false, isSubmit:true });
            let performerData = { ...this.state.performerDetails, is_active: 1, table_name: "lu_performer" }
            ClearTrackService.postDataParams(Constants.ClearTrackServiceBaseUrl + `/staticData`,
                performerData,
                this.props?.userContext?.active_tenant?.tenant_id)
                .then(
                    (response) => {
                        let performerData = {
                            value: response?.data[0]?.id,
                            text: `${this.state.performerDetails?.name}`,
                            warning_notes: this.state.performerDetails?.warning_notes || null,
                        }
                        this.props.handlePerformerUpdate(performerData)
                        this.setState({isSubmit: false})
                    },
                    (err) => {
                        this.setState({ isSubmit: false });
                    }
                )
        }
    };


    getAffilation = () => {
        return ClearTrackService.getData(
            Constants.ClearTrackServiceBaseUrl +
            "/staticData?staticTable=lu_affiliation",
            this.props?.userContext?.active_tenant?.tenant_id
        ).then((response) => {
            return response?.data?.map((item) => ({
                label: item.name,
                value: item.id,
                is_active: item.is_active,
            })) || [];
        });
    };

    loadWriterDetails = () => {
        this.getAffilation().then((useList = []) => {
            if (this.props?.writerId === 'new') {
                this.setState({ affilationOptions: useList.filter(item => item.is_active === 1) });
                return;
            }

            const listWriter = this.props?.songDetails?.writers_list?.[this.props?.selectedWriterIndex];
            const writerText = this.props?.writerId?.text || listWriter?.temp_writer_name || listWriter?.writer_name || '';
            let writerName = writerText;
            let affiliationName = listWriter?.affiliation_name || null;
            let share = listWriter?.share_percentage;

            if (writerText.includes('-')) {
                writerName = writerText.split('-')[0]?.trim() || writerText;
                const textAfterWriterName = writerText.split('-').slice(1).join('-');
                affiliationName = textAfterWriterName?.substring(0, textAfterWriterName?.lastIndexOf(' '))?.trim() || affiliationName;
                share = textAfterWriterName?.split(' ').reverse()[0] || share;
            } else if (writerText.includes('(')) {
                writerName = writerText.substring(0, writerText.indexOf('(')).trim();
                affiliationName = writerText.match(/\(([^)]+)\)/)?.[1]?.trim() || affiliationName;
            }

            const writerdetails = {
                writer_id: this.props?.writerId?.value || listWriter?.writer_id,
                writer_name: writerName,
                affiliation_id: listWriter?.affiliation_id || useList?.find(item => item.label === affiliationName)?.value,
                share_percentage: share ? parseFloat(share) : 0,
                song_id: this.props?.songId,
                song_writer_id: listWriter?.song_writer_id,
                warning_notes: listWriter?.warning_notes || null,
            };

            this.setState({
                writersDetails: writerdetails,
                affilationOptions: useList.filter(item => item.is_active === 1 || item.label === affiliationName),
            });

            if (!writerdetails.writer_id) return;

            loadWriterWarningNotes(
                writerdetails.writer_id,
                writerdetails.writer_name,
                this.props?.userContext?.active_tenant?.tenant_id,
                writerdetails.warning_notes,
                affiliationName,
                writerdetails.affiliation_id
            ).then((warningNotes) => {
                this.setState({
                    writersDetails: {
                        ...writerdetails,
                        warning_notes: warningNotes || null,
                    },
                });
                if (writerdetails.writer_id) {
                    this.showEntityWarningNotes('writer', writerdetails.writer_id, writerdetails.writer_name, warningNotes);
                }
            });
        });
    };

    handleEdit = (field, value, stateName) => {
        this.setState((prevState) => ({
            [stateName]: {
                ...prevState[stateName],
                [field]: value,
            },
            postInitiated: false,
        }));
    };

    render() {
        const isEnable = (this.props?.division_id === undefined ? (this.props?.userContext?.active_tenant?.division_role?.some(item => (['Music Clearance (Admin)', 'Super Admin'].includes(item.role_name))))
        : (this.props?.userContext?.active_tenant?.division_role?.some(item => (['Music Clearance (Admin)', 'Super Admin'].includes(item.role_name) && item.division_id === this.props?.division_id))));
        const warningNotesReadOnly = !canEditWarningNotes(this.props?.userContext) || this.props?.origin === 'fromMainTitleOrClearance';
        
        return (
            <>
                {this.state.isFetchingData ?
                    <div className="ContentLoader">
                        <CircularProgress />
                    </div> :
                     <div>
                     {this.props?.type === 'writer' && <div className="OnFlyLookUP">
                         <MDBRow>
                             <MDBCol md={4}>
                                 <BasicTextField
                                     label="Writer Name"
                                     isMandatory={true}
                                     showMandatory={this.state.postInitiated || false}
                                     placeholder={"- Writer Name -"}
                                     value={this.state.writersDetails?.writer_name}
                                     disabled= {(this.props?.origin==="fromMainTitleOrClearance") || (this.state.writersDetails?.writer_id && !isEnable)}
                                     onChange={(e) =>
                                         this.handleEdit(
                                             "writer_name",
                                             e.target.value.length > 0 ? e.target.value : null,'writersDetails'
                                         )
                                     }
                                 />
                             </MDBCol>
                             <MDBCol md={4}>
                                 <SelectField
                                     id="affilation"
                                     label="Affiliation"
                                     placeholder={"-Affilation -"}
                                     isMandatory={false}
                                     value={this.state.writersDetails?.affiliation_id || null}
                                     options={this.state.affilationOptions || []}
                                     onChange={(e) =>
                                         this.handleEdit("affiliation_id", e.target.value,'writersDetails')
                                     }
                                     disabled = {this.props?.origin==="fromMainTitleOrClearance"}
                                 />
                             </MDBCol>
                            
                             <MDBCol md={4}>
                             <BasicTextField
                             id="share"
                             label="Share"
                             isMandatory={false}
                             placeholder={"__.__"}
                             value={this.state.writersDetails?.share_percentage || this.state.writersDetails?.share || null}
                             onChange={(e)=>
                                this.handleEdit("share_percentage",e.target.value.trim() && !Number.isNaN(Number(e.target.value)) ? parseFloat(e.target.value) : null,'writersDetails')
                            }
                            disabled = {this.props?.origin==="fromMainTitleOrClearance"}
                             />
                         </MDBCol>
                         </MDBRow>
                         <MDBRow>
                             <MDBCol md={12}>
                                 <BasicTextArea
                                     label="Warning Notes"
                                     value={this.state.writersDetails?.warning_notes}
                                     onChange={(e) => this.handleEdit("warning_notes", e.target.value.length > 0 ? e.target.value : null, 'writersDetails')}
                                     disabled={warningNotesReadOnly}
                                 />
                             </MDBCol>
                         </MDBRow>
                     </div>}
                     {this.props?.type === 'cueSheetPublisher' && <div className="OnFlyLookUP">
                         <MDBRow>
                             <MDBCol md={8}>
                                 <BasicTextField
                                     label="Cue Sheet Publisher Name"
                                     isMandatory={true}
                                     showMandatory={this.state.postInitiated || false}
                                     placeholder={"- Cue Sheet Publisher Name -"}
                                     value={this.state.cueSheetPubDetails?.name}
                                     onChange={(e) =>
                                         this.handleEdit(
                                             "name",
                                             e.target.value.length > 0 ? e.target.value : null,'cueSheetPubDetails'
                                         )
                                     }
                                     disabled = {this.props?.origin==="fromMainTitleOrClearance"}
                                 />
                             </MDBCol>
                         </MDBRow>
                         <MDBRow>
                             <MDBCol md={12}>
                                 <BasicTextArea
                                     label="Warning Notes"
                                     value={this.state.cueSheetPubDetails?.warning_notes}
                                     onChange={(e) => this.handleEdit("warning_notes", e.target.value.length > 0 ? e.target.value : null, 'cueSheetPubDetails')}
                                     disabled={warningNotesReadOnly}
                                 />
                             </MDBCol>
                         </MDBRow>
                     </div>}
                     {this.props?.type === 'performer' && <div className="OnFlyLookUP">
                         <MDBRow>
                             <MDBCol md={8}>
                                 <BasicTextField
                                     label="Performer Name"
                                     isMandatory={true}
                                     showMandatory={this.state.postInitiated || false}
                                     placeholder={"- performer Name -"}
                                     value={this.state.performerDetails?.name}
                                     onChange={(e) =>
                                         this.handleEdit(
                                             "name",
                                             e.target.value.length > 0 ? e.target.value : null,'performerDetails'
                                         )
                                     }
                                     disabled = {this.props?.origin==="fromMainTitleOrClearance"}
                                 />
                             </MDBCol>
                         </MDBRow>
                         <MDBRow>
                             <MDBCol md={12}>
                                 <BasicTextArea
                                     label="Warning Notes"
                                     value={this.state.performerDetails?.warning_notes}
                                     onChange={(e) => this.handleEdit("warning_notes", e.target.value.length > 0 ? e.target.value : null, 'performerDetails')}
                                     disabled={warningNotesReadOnly}
                                 />
                             </MDBCol>
                         </MDBRow>
                     </div>}
                     {this.props?.origin!=="fromMainTitleOrClearance" && 
                     <MDBRow>
                         <MDBRow className="p-2">
                             <MDBCol md={6}></MDBCol>
                             <MDBCol md={2}>
                                 <BasicButton
                                     variant="contained"
                                     type="inline"
                                     text={this.state.isSubmit ? <CircularProgress color="inherit" size={18} /> : "Save"}
                                     onClick={() => {
                                         if(this.props?.type === 'writer') {
                                             this.handleWriterSubmit()
                                         }
                                         if(this.props?.type === 'cueSheetPublisher') {
                                            this.postCueSheetPub()
                                         }
                                         if(this.props?.type === 'performer') {
                                            this.postPerformer()
                                         }
                                     }}
                                 />
                             </MDBCol>
                             <MDBCol md={2} >
                                 <BasicButton
                                     type="inline"
                                     variant="outlined"
                                     text={"Close"}
                                     onClick={this.props?.handleClose}
                                 />
                             </MDBCol>
                         </MDBRow>
                     </MDBRow>
                     }
                 </div>}
                <NotificationComponent
                    open={this.state.showDuplicateNotification}
                    message={`The performer "${this.state?.pendingPostJson?.name}" already exists. Cannot add a duplicate.`}
                    severity={"error"}
                    handleResetNotify={this.handleResetNotify.bind(this)}
                />
                {this.state.warningNotesModal?.open &&
                    <WarningNotesModal
                        {...this.state.warningNotesModal}
                        onConfirm={() => closeWarningNotesModal(this)}
                        handleClose={() => closeWarningNotesModal(this)}
                    />
                }
            </>
        );
    }
}
export default withUserContext(OnflyLookup);
